import { get } from '../..';
import { AreaType } from '../../../components/Map/SetFloorsModal/FloorItem';

interface GetBookingsCountProps {
  locationId: string,
  locationSubtype: AreaType,
  from: string,
  to: string,
}

const GetBookingsCount = ({
  locationId, locationSubtype, from, to,
}: GetBookingsCountProps) => {
  let query: string = `metrics/locations/${locationId}/bookings-count`;
  query += `?locationSubtype=${locationSubtype}`;
  query += `&from=${from}&to=${to}`;
  return get(query);
};

export default GetBookingsCount;
